import { render, staticRenderFns } from "./PerformanceEvaluationProcedure.vue?vue&type=template&id=b8f6389a&"
import script from "./PerformanceEvaluationProcedure.vue?vue&type=script&lang=js&"
export * from "./PerformanceEvaluationProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports